import React from 'react'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import { Box } from '@mui/material'
import { EasterEgg, Sledge } from './Themes'

interface Props {
  className?: string
  doRotateBy180Deg?: boolean
  direction: 'in' | 'out' | undefined
}

const EnergyFlowIndicatorSvg: React.FC<Props> = ({ className, doRotateBy180Deg = false, direction }) => {
  const {
    featureFlags: { isChristmasThemeEnabled, isEasterThemeEnabled },
  } = useFeatureFlagsContext()

  if (isChristmasThemeEnabled)
    return (
      <Box className={className}>
        <Sledge doRotateBy180Deg={doRotateBy180Deg} />
      </Box>
    )

  if (isEasterThemeEnabled)
    return (
      <Box className={className} sx={{ position: 'relative' }}>
        <Box sx={{ position: 'relative', top: '5px' }}>
          <EasterEgg doRotateBy180Deg={doRotateBy180Deg} direction={direction} />
        </Box>
      </Box>
    )

  return (
    <Box
      sx={theme => ({
        height: 8,
        width: 18,
        borderRadius: theme.shape.liveViewEnergyFlowIndictor.borderRadius,
        backgroundColor: 'liveView.flowIndicatorInColor',
      })}
      className={className}
    />
  )
}

export default EnergyFlowIndicatorSvg
